import { types } from "../../types/types";

const initialState = {
    usuario: [],
};

export const abmUsuarioPorIdProfesionalReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.abmUsuarioPorIdProfesionalSuccess:
            return {
                ...state,
                usuario: action.payload,
            };
        case types.abmSetUsuarioPorIdProfesional:
            return {
            ...state,
            usuario: state.usuario.map(
                item => item.idCentroMedico === action.payload.idCentroMedico && item.especialidad === action.payload.especialidad
                    ? action.payload
                    : item
                )
            };  
        case types.abmUsuarioPorIdProfesionalError:
            return {
                ...state,
                usuario: [],
            };
        case types.abmUsuarioPorIdProfesionalLimpiar:
            return {
                ...state,
                usuario: [],
            };
        default:
            return state;
    }
  };
  